// estore para sanciones
import sancionesService from '@/services/sanciones.service.js';

export default {
  namespaced: true,
  state: {
    buscar: null,
    estados: [],
    estadoSeleccionado: null,
    sanciones: [],
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
  },
  getters: {
    estados: state => state.estados,
    estadoSeleccionado: state => state.estadoSeleccionado,
  },

  mutations: {
    setEstados(state, estados) {
      state.estados = estados;
    },
    setEstadoSeleccionado(state, estado) {
      state.estadoSeleccionado = estado;
    },
    setBuscar(state, buscar) {
      state.buscar = buscar;
    },
    limpiarFiltros(state) {
      state.estadoSeleccionado = null;
      state.buscar = null;
    },
    setSanciones(state, sanciones) {
      state.sanciones = sanciones;
    },
    setPaginacion(state, { page, per_page, total, last_page }) {
      state.page = page;
      state.per_page = per_page;
      state.total = total;
      state.last_page = last_page;
    },
  },
  actions: {
    async fetchEstados({ commit }) {
      try {
        const url = '/api/catalogos/sanciones-estados';
        const response = await this._vm.$http_client ? this._vm.$http_client(url, {}, 'get') : await import('@/plugins/http_client').then(m => m.http_client(url, {}, 'get'));
        // la respuesta puede venir como response.data o directamente response
        const apiData = response?.data || response;
        // asumimos que la data llega en apiData.data o apiData
        const estados = apiData?.data || apiData || [];
        // Normalizar a array de objetos {id, nombre}
        const normalized = Array.isArray(estados)
          ? estados.map(e => ({ id: e.id || e.value || null, nombre: e.nombre || e.label || e.descripcion || e.name || '' }))
          : [];

        commit('setEstados', normalized);
      } catch (error) {
        console.error('Error fetching sanciones estados, usando fallback:', error);
        const data = [
          { id: 1, nombre: 'En análisis juridico' },
          { id: 2, nombre: 'En proceso' },
          { id: 3, nombre: 'Finalizado' },
          { id: 4, nombre: 'No procede' },
          { id: 5, nombre: 'Remitido a externo' },
          { id: 6, nombre: 'Remitido a RRHH' },
        ];
        commit('setEstados', data);
      }
    },
    seleccionarEstado({ commit }, estado) {
      commit('setEstadoSeleccionado', estado);
    },
    actualizarBuscar({ commit }, buscar) {
      commit('setBuscar', buscar);
    },
    limpiarFiltros({ commit }) {
      commit('limpiarFiltros');
    },

    async fetchSanciones({ state, commit }, payload = {}) {
      commit('setSanciones', []);

      const rawSearch = payload.search !== undefined ? payload.search : (payload.buscar !== undefined ? payload.buscar : state.buscar);
      const search = rawSearch !== null && rawSearch !== undefined ? String(rawSearch).trim() : '';
      const estado = payload.estado !== undefined
        ? payload.estado
        : (state.estadoSeleccionado ? (state.estadoSeleccionado.id || state.estadoSeleccionado) : null);

      const filters = {
        search: search || '',
        estado: estado || null,
        empleadoId: payload.empleadoId || null,
        unidadId: payload.unidadId || null,
        desde: payload.desde || null,
        hasta: payload.hasta || null,
  page: payload.page || state.page || 1,
  size: payload.size || payload.per_page || state.per_page || 10,
        sort: payload.sort || 'created_at',
        sortDirection: payload.sortDirection || 'desc',
      };

      try {
        const response = await sancionesService.fetchSanciones(filters);
        commit('setSanciones', response.data || []);
        commit('setPaginacion', {
          page: response.page || 1,
          per_page: response.perPage || 10,
          total: response.total || 0,
          last_page: response.lastPage || 1,
        });
      } catch (error) {
        console.error('Error en fetchSanciones store:', error);
        commit('setSanciones', []);
        commit('setPaginacion', { page: 1, per_page: 10, total: 0, last_page: 1 });
      }
    },
  },
};
